import { queryAll, query, fromId } from '../utils/utils.js';

export class LocationsSpotlight {


    constructor() {

        queryAll('.locations-spotlight-block').forEach((spotlight) => {
            this.initSpotlightBlock( spotlight );
        });

    }

    initSpotlightBlock( spotlight ) {

        const collapsible = spotlight.querySelector('.spotlight-locations');
        const background = spotlight.querySelector('.background');

        collapsible.addEventListener('hide.bs.collapse', function () {
            background.classList.add('collapsed');
        });

        collapsible.addEventListener('show.bs.collapse', function () {
            background.classList.remove('collapsed');
        });

    }

}